/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  GET_FORM_DEFINITION,
  GET_FORM_DEFINITION_SUCCESS,
  GET_FORM_DEFINITION_ERROR,
  MOVE_FORM_DEFINITION_LINE,
  MOVE_FORM_DEFINITION_LINE_SUCCESS,
  MOVE_FORM_DEFINITION_LINE_ERROR,
  SET_BACK_TO_FORM_LINES_DEFINITION_LIST,
  SET_FORM_DEFINITION_PARTY_TYPE,
  SET_FORM_DEFINITION_GROUP_TYPE,
  SET_VALUES_AUTO_MOVE_FORM_ROWS,
  SET_FORM_LINES_DEFINITION,
  SET_VISIBLE_MODAL_FORM_NUMBER,
  SET_VALUES_FORM_APPLY_SHARE_CODE,
  VERIFY_CODE,
  VERIFY_CODE_SUCCESS,
  VERIFY_CODE_ERROR,
  APPLY_SHARE_CODE,
  APPLY_SHARE_CODE_SUCCESS,
  APPLY_SHARE_CODE_ERROR,
} from 'src/actions/formDefinitionActions';

const backToFormDefinitionList = {
  formDefinitionId: null,
  formLinesDefinition: [],
  active: false,
  comeBack: false,
  backToId: null,
  startFormLineDefinitionFromId: null,
  initScrollToId: false,
};

const formApplyShareCode = {
  loading: false,
  shareCode: '',
  validCode: true,
  formDefinitionOwnerFirstName: '',
  formDefinitionOwnerLastName: '',
  formDefinitionName: '',
};

const initialState = {
  partyTypeId: null,
  groupTypeId: null,
  formDefinition: {},
  formDefinitionId: null,
  formLinesDefinition: [],
  loading: false,
  backToFormDefinitionList,
  autoMoveFormRows: true,
  visibleModalFormNumber: null,
  formApplyShareCode,
};

const formDefinitionReducer = (state = initialState, formDefinition) => {
  const { type, payload } = formDefinition;
  switch (type) {
    case GET_FORM_DEFINITION: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case GET_FORM_DEFINITION_SUCCESS: {
      return produce(state, (draft) => {
        draft.formDefinition = payload?.formDefinition || {};
        draft.formDefinitionId = payload?.formDefinitionId || null;
        draft.formLinesDefinition = payload?.formLinesDefinition || [];
        draft.loading = false;
      });
    }

    case GET_FORM_DEFINITION_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case MOVE_FORM_DEFINITION_LINE: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case MOVE_FORM_DEFINITION_LINE_SUCCESS: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case MOVE_FORM_DEFINITION_LINE_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case SET_BACK_TO_FORM_LINES_DEFINITION_LIST: {
      return produce(state, (draft) => {
        draft.backToFormDefinitionList = payload ? {
          ...state.backToFormDefinitionList,
          ...payload,
        } : backToFormDefinitionList;
      });
    }

    case SET_FORM_DEFINITION_PARTY_TYPE: {
      return produce(state, (draft) => {
        draft.partyTypeId = payload || null;
        draft.groupTypeId = null;
        draft.formDefinitionId = null;
        draft.formDefinition = {};
        draft.formLinesDefinition = [];
        draft.loading = false;
      });
    }

    case SET_FORM_DEFINITION_GROUP_TYPE: {
      return produce(state, (draft) => {
        draft.groupTypeId = payload || null;
        draft.partyTypeId = null;
        draft.formDefinitionId = null;
        draft.formDefinition = {};
        draft.formLinesDefinition = [];
        draft.loading = false;
      });
    }

    case SET_VISIBLE_MODAL_FORM_NUMBER: {
      return produce(state, (draft) => {
        draft.visibleModalFormNumber = payload || null;
      });
    }

    case SET_VALUES_AUTO_MOVE_FORM_ROWS: {
      return produce(state, (draft) => {
        draft.autoMoveFormRows = payload;
      });
    }

    case SET_FORM_LINES_DEFINITION: {
      return produce(state, (draft) => {
        draft.formLinesDefinition = payload || [];
      });
    }

    case VERIFY_CODE: {
      return produce(state, (draft) => {
        draft.formApplyShareCode.loading = true;
      });
    }

    case VERIFY_CODE_SUCCESS: {
      return produce(state, (draft) => {
        draft.formApplyShareCode.validCode = true;
        draft.formApplyShareCode.loading = false;
        draft.formApplyShareCode.formDefinitionOwnerFirstName = payload?.formDefinitionOwnerFirstName || [];
        draft.formApplyShareCode.formDefinitionOwnerLastName = payload?.formDefinitionOwnerLastName || [];
        draft.formApplyShareCode.formDefinitionName = payload?.formDefinitionName || [];
      });
    }

    case VERIFY_CODE_ERROR: {
      return produce(state, (draft) => {
        draft.formApplyShareCode.loading = false;
        draft.formApplyShareCode.validCode = false;
      });
    }

    case SET_VALUES_FORM_APPLY_SHARE_CODE: {
      return produce(state, (draft) => {
        draft.formApplyShareCode = payload ? {
          ...state.formApplyShareCode,
          ...payload,
        } : formApplyShareCode;
      });
    }

    case APPLY_SHARE_CODE: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case APPLY_SHARE_CODE_SUCCESS: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case APPLY_SHARE_CODE_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    default: {
      return state;
    }
  }
};

export default formDefinitionReducer;
